@if (loading) {
  <div class="loading-container">
    <mat-spinner></mat-spinner>
    <p>Carregando comunicado...</p>
  </div>
}

@if (!loading && communication) {
  <div class="communication-details">
    <div class="header">
      <h1>{{ communication.title }}</h1>
      @if (isOwner) {
        <button
          mat-raised-button
          color="warn"
          (click)="deleteCommunication()"
          >
          <mat-icon>delete</mat-icon>
          Excluir
        </button>
      }
    </div>
    <div class="creation-time">
      Criado em: {{ communication.createDate | date:'dd/MM/yyyy HH:mm' }}
    </div>
    <div class="body">
      {{ communication.body }}
    </div>
  </div>
} @else {
  @if (!loading && error) {
    <div class="error">
      {{ error }}
    </div>
  }
}

